import { useAuthStore } from "@/store/auth";
import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import { getDefaultRoute, hasFeatureAccess } from "@/utils/routing";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredFeature?: string;
  adminOnly?: boolean;
}

export function ProtectedRoute({
  children,
  requiredFeature,
  adminOnly,
}: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);

  // Check authentication first
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Internal admin gate
  if (adminOnly && !user?.isInternalAdmin) {
    const allowedFeatures = user?.portalConfig?.allowed_features || [];
    return <Navigate to={getDefaultRoute(allowedFeatures)} replace />;
  }

  // Get user's allowed features
  const allowedFeatures = user?.portalConfig?.allowed_features || [];

  // Check feature access if requiredFeature is specified
  if (requiredFeature && !hasFeatureAccess(requiredFeature, allowedFeatures)) {
    // Redirect to user's default route if they don't have access
    const defaultRoute = getDefaultRoute(allowedFeatures);
    return <Navigate to={defaultRoute} replace />;
  }

  return <>{children}</>;
}
